<template>
  <div>
    <div v-if="!asyncAnimProps.hasPlayer">
      <div class="async-anim">
        <lottie :options="defaultOptions" :width="svgWidth()" :height="svgHeight()" @animCreated="handleAnimation"/>
      </div>
    </div>
    <div class="async-anim-player" v-if="asyncAnimProps.hasPlayer">
      <div class="v-align-wrapper" :style="{height: asyncAnimProps.playerHeight}">
        <div class="v-align">
          <div class="async-anim">
            <lottie :options="defaultOptions" :width="svgWidth()" :height="svgHeight()" @animCreated="handleAnimation"/>
          </div>
        </div>
      </div>
      <div class="async-anim-controller">
        <div v-if="isPlaying" @click="pause" class="p-1"><i class="fa fa-pause-circle"></i></div>
        <div v-if="!isPlaying" @click="play" class="p-1"><i class="fa fa-play-circle"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie/src/lottie.vue'
import * as projectsAnim from '@/../static/LINES_Projects.json'
import * as aboutAnim from '@/../static/LINES_About.json'
import * as contactAnim from '@/../static/LINES_Contact.json'
import * as inputMethodsAnim from '@/../static/SSFA_InputMethods.json'
import * as fileSavingAnim from '@/../static/SSFA_FileSaving.json'
import * as storeGoalsAnim from '@/../static/SSFA_StoreGoals.json'
import * as modalsAnim from '@/../static/SSFA_Modals.json'
import * as vennAnim from '@/../static/SSFA_VennDiagram.json'
import * as heroAnim from '@/../static/hero.json'
import * as bearAnim from '@/../static/bear.json'

export default {
  name: 'asyncAnimation',
  components: {
    Lottie
  },
  props: ['asyncAnimProps'],
  data: function () {
    return {
      animations: {
        'projectsAnim': projectsAnim,
        'aboutAnim': aboutAnim,
        'contactAnim': contactAnim,
        'inputMethodsAnim': inputMethodsAnim,
        'fileSavingAnim': fileSavingAnim,
        'storeGoalsAnim': storeGoalsAnim,
        'modalsAnim': modalsAnim,
        'vennAnim': vennAnim,
        'heroAnim': heroAnim,
        'bearAnim': bearAnim,
      },
      defaultOptions: {},
      isPlaying: 1,
    }
  },
  created: function () {
    this.defaultOptions = {
      animationData: this.animations[this.asyncAnimProps.name],
      animationSpeed: 1,
      autoplay: this.asyncAnimProps.hasPlayer || false,
      loop: this.asyncAnimProps.hasPlayer || false,
      renderer: 'html',
    }
  },
  mounted: function () {
    this.delay()
  },
  methods: {
    delay: function () {
      if (this.asyncAnimProps.hasPlayer) return
      this.anim.pause()
      setTimeout(function() {this.anim.play()}.bind(this), this.asyncAnimProps.delay || 0)
    },
    handleAnimation: function (anim) {
      this.anim = anim
      if (this.asyncAnimProps.hasPlayer) return
      const onComplete = function (evt) {
        if (this.asyncAnimProps && this.asyncAnimProps.onComplete) {
          if (this.asyncAnimProps.onComplete == 'loop') {
            return this.manualLoop(this.anim)
          } else {
            return this.asyncAnimProps.onComplete(evt)
          }
        }
      }.bind(this)
      this.anim.addEventListener('complete', onComplete)
    },
    pause: function () {
      this.isPlaying = 0
      this.anim.pause()
    },
    play: function () {
      this.isPlaying = 1
      this.anim.play()
    },
    manualLoop: function (anim) {
      setTimeout(function() {
        anim.goToAndPlay(0, false)
      }.bind(this), this.asyncAnimProps.delay || 0)
    },
    svgHeight: function () {
      if (this.scrollAnimProps && this.scrollAnimProps.height && Number.isInteger(this.scrollAnimProps.height)) {
        return this.scrollAnimProps.height
      }
      return 0
    },
    svgWidth: function () {
      if (this.scrollAnimProps && this.scrollAnimProps.width && Number.isInteger(this.scrollAnimProps.width)) {
        return this.scrollAnimProps.width
      }
      return 0
    },
  },
}
</script>

<style lang="scss">
.v-align-wrapper {
  position: relative;
  .v-align {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.async-anim-controller {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AsyncAnimation.vue